import { createContext, useState } from "react";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(
    Number(localStorage.getItem("notification")) || 0
  );

  const updateNotification = (value) => {
    setNotification(value);
    localStorage.setItem("notification", value);
  };

  return (
    <NotificationContext.Provider value={{ notification, updateNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};
